import m, {MithrilComponent} from '@bitstillery/mithril'
import {PortalAuthDialog} from '@bitstillery/common/components/portal'

import {AuthRegistration} from '@/components/pages/auth/registration/registration'
import {$m} from '@/app'

/**
 * Route-driven auth dialog (login / register / forgot-password / reset-password).
 * Rendered by the content frame whenever the URL is an auth route, over the home page.
 * Injects the portal registration flow and the default login-success handler.
 */
export class DialogAuth extends MithrilComponent {
    view(): m.Children {
        return (
            <PortalAuthDialog
                RegistrationComponent={AuthRegistration}
                on_login_success={async (token: string) => {
                    await $m.identity.new_token(token)
                }}
            />
        )
    }
}
